app.directive("paginator",["_$paginator",function(_$paginator){
 
    return {
      
            restrict:"E",
            templateUrl:"/assets/js/angular/components/directives/paginator/paginator.html",
            scope:{
                options:"=",//options for paginator {count:all,page: current page}
                changePage:"="//callback on page change
            },
            link:function(scope){
                
                scope.perPage=_$paginator.getPerPage;
//                scope.$watch("perPage");
//                scope.$watch("options");
            }
            
            
        
        
    };
        
}]);


